import React, { useState } from 'react';
import { User, Users } from 'lucide-react';

const COLORS = [
    'bg-red-500', 'bg-orange-500', 'bg-amber-500', 'bg-yellow-500', 'bg-lime-500',
    'bg-green-500', 'bg-emerald-500', 'bg-teal-500', 'bg-cyan-500', 'bg-sky-500',
    'bg-blue-500', 'bg-indigo-500', 'bg-violet-500', 'bg-purple-500', 'bg-fuchsia-500',
    'bg-pink-500', 'bg-rose-500'
];

// Gradient map: elke basiskleur krijgt een mooie top-to-bottom gradient
const GRADIENT_MAP = {
    'bg-red-500': 'from-red-400 to-red-600',
    'bg-orange-500': 'from-orange-400 to-orange-600',
    'bg-amber-500': 'from-amber-400 to-amber-600',
    'bg-yellow-500': 'from-yellow-400 to-yellow-600',
    'bg-lime-500': 'from-lime-400 to-lime-600',
    'bg-green-500': 'from-green-400 to-green-600',
    'bg-emerald-500': 'from-emerald-400 to-emerald-600',
    'bg-teal-500': 'from-teal-400 to-teal-600',
    'bg-cyan-500': 'from-cyan-400 to-cyan-600',
    'bg-sky-500': 'from-sky-400 to-sky-600',
    'bg-blue-500': 'from-blue-400 to-blue-600',
    'bg-indigo-500': 'from-indigo-400 to-indigo-600',
    'bg-violet-500': 'from-violet-400 to-violet-600',
    'bg-purple-500': 'from-purple-400 to-purple-600',
    'bg-fuchsia-500': 'from-fuchsia-400 to-fuchsia-600',
    'bg-pink-500': 'from-pink-400 to-pink-600',
    'bg-rose-500': 'from-rose-400 to-rose-600',
};

export const TeamAvatar = ({ name, logoUrl, size = "md", className = "" }) => {
    const [imgError, setImgError] = useState(false);

    // Grootte + font
    const sizeClasses = {
        sm: "w-8 h-8 text-xs",
        md: "w-12 h-12 text-base",
        lg: "w-24 h-24 text-3xl",
        xl: "w-32 h-32 text-4xl"
    };

    // Kleur: voorspelbaar op basis van naam-hash
    const getColor = (str) => {
        if (!str) return COLORS[0];
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return COLORS[Math.abs(hash) % COLORS.length];
    };

    // Initialen (max 2 letters)
    const getInitials = (str) => {
        if (!str) return "?";
        return str
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    const isLarge = size === 'lg' || size === 'xl';
    // Subtiele witte ring geeft diepte op elke achtergrond
    const ringClass = 'ring-2 ring-white ring-offset-1';
    const shadowClass = isLarge ? 'shadow-lg' : 'shadow-sm';
    const containerClass = `${sizeClasses[size] || sizeClasses.md} rounded-full flex items-center justify-center overflow-hidden shrink-0 ${ringClass} ${shadowClass} ${className}`;

    // Logo afbeelding
    if (logoUrl && !imgError) {
        return (
            <div className={`${containerClass} bg-gray-100`}>
                <img
                    src={logoUrl}
                    alt={name}
                    className="w-full h-full object-cover"
                    onError={() => setImgError(true)}
                />
            </div>
        );
    }

    // Fallback: initialen met gradient achtergrond
    const baseColor = getColor(name);
    const gradient = GRADIENT_MAP[baseColor] || 'from-indigo-400 to-indigo-600';

    return (
        <div className={`${containerClass} bg-gradient-to-br ${gradient} text-white font-bold`}>
            {getInitials(name)}
        </div>
    );
};
